<script type="text/jsx" lang="jsx">
import { mapGetters } from 'vuex';

export default {
  name: 'vAmountLoading',
  computed: {
    ...mapGetters(['computedAmountLoading']),
  },
  render() {
    if (this.computedAmountLoading) {
      return <zm-spinners size="sm" type="circle" />;
    }

    return this.$slots.default?.();
  },
};
</script>

<style lang="scss" scoped>
.opc-v-amount-loading {
}
</style>
